// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import Zone from "@insite/client-framework/Components/Zone";
import { Category } from "@insite/client-framework/Services/CategoryService";
import { getProductCollectionV2 } from "@insite/client-framework/Services/ProductServiceV2";
import setBreadcrumbs from "@insite/client-framework/Store/Components/Breadcrumbs/Handlers/SetBreadcrumbs";
import { CategoryModel } from "@insite/client-framework/Types/ApiModels";
import { PageModel } from "@insite/client-framework/Types/PageProps";
import { LinkProps } from "@insite/mobius/Link";
import Page from "@insite/mobius/Page";
import { getPromotionTree } from "@store/Framework/Services/PromotionTreeService";
import useQueryString from "@toolkit/Framework/Common/Hooks/useQueryString";
import { useLocation } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { stringify } from "qs";
import React, { useEffect } from "react";

const collapseDirectLinkInTree = (rootCategory: CategoryModel, nextCategory: CategoryModel) => {
    const subCategories = nextCategory.subCategories || [];

    if (subCategories.length === 1) {
        collapseDirectLinkInTree(rootCategory, subCategories[0]);
    }
    if (subCategories.length === 0) {
        rootCategory.subCategories = [];
    }
    if (subCategories.length > 1) {
        rootCategory.subCategories = nextCategory.subCategories;
    }
};
const removeCategoriesWithOnlyOneSubCategory = (categories: CategoryModel[]) => {
    categories.forEach(category => {
        if (category.subCategories && category.subCategories.length === 1) {
            collapseDirectLinkInTree(category, category.subCategories[0]);
        }
        if (category.subCategories && category.subCategories.length > 1) {
            removeCategoriesWithOnlyOneSubCategory(category.subCategories);
        }
    });
};

const getBreadCrumbLinks = (rootUrl: string, paths: string[]): LinkProps[] => {
    const rootLinks = [
        {
            children: "Home",
            href: "/",
            type: "HomePage",
        },
        {
            children: rootUrl.substring(1),
            href: `${rootUrl}`,
            type: "PromotionDetailPage",
        },
    ];

    const links = paths.map((path, index) => {
        const pathSegments = paths.slice(0, index + 1);
        const queryString = stringify({ path: pathSegments }, { arrayFormat: "brackets" });
        return {
            children: path,
            type: "PromotionDetailPage",
            href: `${rootUrl}${queryString ? `?${queryString}` : ""}`,
        };
    });

    return [...rootLinks, ...links];
};
const PromotionDetailPage = ({ id }: PageModel) => {
    const location = useLocation();
    const { path = [] } = useQueryString<{ path: string[] }>();
    const lastUrlSegment = location.pathname;

    const [categoryContextData, setCategoryContextData] = React.useState<Category>();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!lastUrlSegment) {
            return;
        }
        const getCategories = async () => {
            const products = await getProductCollectionV2({
                search: lastUrlSegment,
                expand: ["attributes", "facets"],
            });

            const promotionTree = await getPromotionTree({
                leafCategoryIds: products.categoryFacets?.map(facet => facet.categoryId) ?? [],
            });
            dispatch(setBreadcrumbs({ links: getBreadCrumbLinks(lastUrlSegment, path) }));
            removeCategoriesWithOnlyOneSubCategory(promotionTree?.categories || []);
            path.forEach((pathSegment: string) => {
                const category = promotionTree.categories?.find(c => c.shortDescription === pathSegment);
                if (category) {
                    promotionTree.categories = category.subCategories;
                }
            });
            if (promotionTree.categories) {
                promotionTree.categories = promotionTree.categories?.map(category => {
                    const queryString = stringify(
                        { path: [...path, category.shortDescription] },
                        { arrayFormat: "brackets" },
                    );
                    if (category.subCategories && category.subCategories.length > 0) {
                        category.path = `${lastUrlSegment}${queryString ? `?${queryString}` : ""}`;
                    } else {
                        category.path = `/Search?query=${lastUrlSegment.substring(1)}&categoryId=${category.id}`;
                    }

                    return category;
                });
            }

            const subCategoryIds = promotionTree.categories?.map(category => category.id) ?? [];

            dispatch({
                type: "Pages/PromotionTree/LoadPromotionTree",
                categories: promotionTree.categories,
            });

            setCategoryContextData({
                subCategoryIds,
            } as Category);
        };
        getCategories();
    }, [path.toString()]);
    if (!categoryContextData) {
        return null;
    }
    return (
        <Page>
            <Zone contentId={id} zoneName="Content"></Zone>
        </Page>
    );
};

const pageModule = {
    component: PromotionDetailPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;
